import { SAVE_FILE, FETCH_FILES, FETCH_EXERCISE_VIDEOS, RESET_FILES } from "../actionTypes"

export default (state={
    data: [],
    isLoadMore: false
  }, action=null) => {
  switch(action.type) {
    case FETCH_FILES: 
      return {
        data: [...state.data, ...Object.values(action.payload.data) ],
        isLoadMore: Object.keys(action.payload.data).length < 10 ? false : true
      }
    case FETCH_EXERCISE_VIDEOS:
      return {
        ...state,
        ...action.payload
      }
    case RESET_FILES:
      console.log('reset_files')
      return {
        data: [],
        isLoadMore: false
      }
    case SAVE_FILE:
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/files.js